<template>
  <div class="story-container">
    <div class="story-container-left">
      <div class="story-title-content">
        <h1>{{ this.currentRouteName }}</h1>
      </div>
    </div>
    <div class="story-container-right">
      <div class="story-subtitle-content">
        <transition name="slide-left" mode="out-in">
          <router-view class="story-child-view"></router-view>
        </transition>
      </div>
    </div>
    <access-modal-left></access-modal-left>
    <access-modal-right></access-modal-right>
  </div>
</template>

<script>
import AccessModalLeft from "../components/AccessModalTitle.vue";
import AccessModalRight from "../components/AccessModal.vue";
export default {
  name: "StoryView",
  data() {
    return {
      currentRouteName: `${this.$route.name}`
    };
  },
  components: {
    AccessModalLeft,
    AccessModalRight
  },
  watch: {
    $route() {
      if (this.$route.name == "End") {
        this.currentRouteName = `${this.$route.name}`;
      } else {
        this.currentRouteName = `Part ${this.$route.name}`;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/css/Scheme.scss";
.story-container {
  /* background-color: $color_red; */
  color: white;
  font-family: $font_first;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  .story-container-left {
    background-color: $color_black;
    min-width: 414px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 50%;
    .story-title-content {
      text-align: center;
      width: 65vh;
    }
  }
  .story-container-right {
    min-width: 414px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 50%;
    background-color: white;
    .story-subtitle-content {
      color: $color_black;
      font-family: $font_second;
      font-size: 1em;
    }
  }
  .story-child-view {
    transition: all 1s;
  }
}

.slide-left-enter {
  opacity: 0;
  -webkit-transform: translate(100px, 0);
  transform: translate(-100px, 0);
}
.slide-left-leave-active {
  opacity: 0;
  -webkit-transform: translate(-100px, 0);
  transform: translate(100px, 0);
}
</style>
